import React from 'react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1A2733] border-t border-[#506273]/30 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-6">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-[#30D5C8] rounded-lg flex items-center justify-center">
              <svg
                className="w-6 h-6 text-[#1A2733]"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="6" cy="12" r="2" fill="currentColor" />
                <path d="M12 6 L12 18" />
                <path d="M9 9 L15 9" />
                <path d="M9 15 L15 15" />
                <path d="M18 12 L22 12" />
                <path d="M20 10 L22 12 L20 14" />
              </svg>
            </div>
            <div>
              <div className="text-[#F5F7F8] font-bold text-lg font-['Montserrat'] tracking-tight">
                PROJECTFLOW™
              </div>
              <div className="text-[#CBD3D9] text-xs font-['Montserrat'] tracking-wider">
                AUTOMATIONS
              </div>
            </div>
          </div>

          {/* Tagline */}
          <p className="text-[#CBD3D9] font-['Open_Sans'] text-center max-w-md">
            Automation engineered for reality — not theory.
          </p>

          {/* Footer Links */}
          <div className="flex items-center gap-6">
            <a
              href="/privacy-policy"
              className="text-[#CBD3D9] hover:text-[#30D5C8] font-['Open_Sans'] text-sm transition-colors"
            >
              Privacy Policy
            </a>
          </div>

          {/* Legal Notices */}
          <div className="pt-4 space-y-3 text-center max-w-4xl">
            <p className="text-[#506273] font-['Open_Sans'] text-xs leading-relaxed">
              ProjectFlow™, TimeSync™, SiteSync™, UpdateFlow™ and related marks are trademarks of ProjectFlow Automations Co.
            </p>
            <p className="text-[#506273] font-['Open_Sans'] text-xs leading-relaxed">
              Patents Pending. Proprietary technology and processes protected under U.S. and international intellectual property laws.
            </p>
          </div>

          {/* Copyright */}
          <div className="pt-6 border-t border-[#506273]/30 w-full text-center space-y-2">
            <p className="text-[#506273] font-['Open_Sans'] text-sm">
              © {currentYear} ProjectFlow Automations Co. All rights reserved.
            </p>
            <p className="text-[#506273] font-['Open_Sans'] text-xs">
              Unauthorized use, reproduction, or distribution of this technology is strictly prohibited.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};